import { get } from "../../../../static/assets/utilities/ajax.js";

class ElementorAjaxSearchControl {
    constructor() {
        console.log("Custom Elementor control initializing...");
        this.init();
    }

    init() {
        if (this.isElementorReady()) {
            this.registerControl();
        } else {
            this.waitForElementor();
        }
    }

    isElementorReady() {
        return typeof elementor !== 'undefined' && elementor.modules?.controls;
    }

    waitForElementor() {
        const checkInterval = setInterval(() => {
            if (this.isElementorReady()) {
                clearInterval(checkInterval);
                this.registerControl();
            }
        }, 500);
    }

    registerControl() {
        const AjaxSelectControl = elementor.modules.controls.Select2.extend({
            onReady: function () {
                this.setupSelect2();
            },

            onBeforeDestroy: function () {
                this.destroySelect2();
            },

            setupSelect2: function () {
                const self = this;
                const selectEl = self.$el.find('.streamit_elementor_select2_ajax_search');
                const ajaxAction = selectEl.data('ajax-action');
                const minInput = selectEl.data('min-input-length');
                const placeholder = selectEl.data('placeholder');

                // Read extra AJAX params
                let extraParams = {};
                const dataAttr = selectEl.attr('data-ajax-params');
                if (dataAttr) {
                    try {
                        extraParams = JSON.parse(dataAttr);
                    } catch (e) {
                        console.error(`Invalid JSON in data-ajax-params:`, dataAttr);
                    }
                }
                extraParams.elementor_post_id = elementor.config.post_id;

                // Collect preselected values (IDs only)
                const selectedIDs = selectEl.val();

                // If widget has saved IDs → fetch real labels first
                if (selectedIDs && selectedIDs.length) {

                    get(ajaxAction, {
                        preload_ids: selectedIDs,
                        ...extraParams
                    }).done((response) => {

                        // Replace <option> list with real movie names
                        selectEl.empty();
                        if (response.success && Array.isArray(response.data?.items)) {
                            response.data.items.forEach(item => {
                                selectEl.append(new Option(item.text, item.id, true, true));
                            });
                        }

                        // Now initialize Select2 normally
                        self.initSelect2Ajax(selectEl, ajaxAction, extraParams, response.data, self);
                    });

                } else {

                    // No saved values → initialize normally
                    self.initSelect2Ajax(selectEl, ajaxAction, extraParams, [], self);
                }

                selectEl.on('change', () => {
                    self.setValue(selectEl.val());
                });
            },


            /**
             * Initialize a single Select2 with AJAX + infinite scroll support
             * @param {jQuery} $field - jQuery object for the field
             * @param {string} route - backend route name for AJAX
             * @param {object} extraParams - extra params to send with AJAX
             * @param {array} initialData - preselected values [{id,text}]
             * @param {object} controlInstance - Elementor control instance
             */
            initSelect2Ajax: function ($field, route, extraParams = {}, initialData = null, controlInstance = null) {
                $field.select2({
                    width: '100%',
                    placeholder: 'Select an option',
                    allowClear: true,
                    dropdownParent: controlInstance ? controlInstance.$el : $field.parent(),
                    minimumInputLength: $field.data('min-input-length') || 2,
                    ajax: {
                        transport: (params, success, failure) => {
                            const data = {
                                search: params.data.term || '',
                                page: params.data.page || 1,
                                ...extraParams,
                            };

                            get(route, data)
                                .done(success)
                                .fail(failure);
                        },
                        delay: 250,
                        dataType: 'json',
                        processResults: (response, params) => {
                            params.page = params.page || 1;

                            let results = [];
                            if (response.success && Array.isArray(response.data?.items)) {
                                results = response.data.items.map(item => ({
                                    id: item.id,
                                    text: item.text,
                                }));
                            } else if (response.success && response.data?.results) {
                                // Fallback to original structure for compatibility
                                results = response.data.results;
                            }

                            return {
                                results,
                                pagination: {
                                    more: response.data?.hasMore || response.data?.pagination?.more || false,
                                },
                            };
                        },
                        cache: true,
                    },
                    language: {
                        inputTooShort: (args) =>
                            `Please enter ${args.minimum - args.input.length} or more characters.`
                    }
                });

                // Handle preselected values for edit forms
                if (initialData && initialData.length > 0) {
                    const selectedItems = Array.isArray(initialData) ? initialData : [initialData];
                    selectedItems.forEach(item => {
                        if (!$field.find(`option[value='${item.id}']`).length) {
                            const newOption = new Option(item.text, item.id, true, true);
                            $field.append(newOption);
                        }
                    });
                    $field.trigger('change');
                }
            },

            destroySelect2: function () {
                const selectEl = this.$el.find('.elementor-select-ajax');
                if (selectEl.data('select2')) {
                    selectEl.select2('destroy');
                }
            }
        }, {
            controlType: 'st_ajax_select'
        });

        elementor.addControlView('st_ajax_select', AjaxSelectControl);
        console.log("Custom Elementor control registered successfully!");
    }
}

// Initialize the control
new ElementorAjaxSearchControl();